import React from 'react'
import { createNativeStackNavigator } from '@react-navigation/native-stack'

import Loading from './Loading'
import Unavailable from './Unavailable'
import Welcome from './Welcome'
import SignNavigator from './Sign'
import QuickBottomTabsNavigator from './QuickBottomTabsNavigator'
import Help from './Help'
const Stack = createNativeStackNavigator()

function AppNavigator() {
  return (
    <Stack.Navigator
      initialRouteName='Loading'
      screenOptions={{
        headerShown:false
      }}
    >
      <Stack.Screen
        name="Loading"
        component={Loading}
      />
      <Stack.Screen
        name="Welcome"
        component={Welcome}
      />
      <Stack.Screen
        name="Sign"
        component={SignNavigator}
        options={{gestureEnabled: false}}
      />
      <Stack.Screen
        name="Unavailable"
        component={Unavailable}
      />
      <Stack.Screen
        name="Main"
        component={QuickBottomTabsNavigator}
         options={{gestureEnabled: false}}
      />
      <Stack.Screen
        name="Help"
        component={Help}
      />
    </Stack.Navigator>
  )
}

export default AppNavigator
